<template>
  <div class="astrology-container h-100 my-3">
    <div class="h-100">
      <b-row class="h-100 m-0">
        <b-col xl="4" lg="5" md="8" class="m-auto">
          <div class="astrology-form-container">
            <b-container class="p-0 pm-2">
              <b-card
                class="
                  card-astrology card-dark-transparent-background-astrology
                  my-1
                  py-0
                "
              >
                <b-card-text class="card-text-form-subtitle"
                  >To create your interactive Birth chart please share your
                  Be-Earth (Birth) information
                </b-card-text>
                <b-form @submit.prevent="onSubmit">
                  <b-row>
                    <b-col>
                      <b-form-group
                        class="form-group-astrology"
                        label-for="name"
                        label="Name"
                        label-class="form-label-astrology"
                      >
                        <b-form-input
                          class="form-control form-control-astrology"
                          id="name"
                          v-model="_name"
                          type="text"
                          placeholder="Name"
                          required
                        ></b-form-input> </b-form-group></b-col
                  ></b-row>
                  <b-row>
                    <b-col>
                      <b-form-group
                        class="form-group-astrology form-group-select-astrology"
                        label-for="gender"
                        label="Gender"
                        label-class="form-label-astrology"
                      >
                        <p
                          v-if="invalid_gender"
                          class="error_validation_message_p_astrology"
                        >
                          Please select gender
                        </p>
                        <v-select
                          class="v-select-astrology"
                          :options="gender_options"
                          name="gender"
                          title="gender"
                          v-model="_gender"
                          :clearable="false"
                          :reduce="(item) => item.code"
                          placeholder="Select gender"
                        ></v-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <b-form-group
                        class="form-group-astrology form-group-date-astrology"
                        label-for="date"
                        label="Date"
                        label-class="form-label-astrology"
                      >
                        <p
                          v-if="invalid_date"
                          class="error_validation_message_p_astrology"
                        >
                          Please enter date
                        </p>
                        <date-picker
                          v-model="_date"
                          type="date"
                          value-type="YYYY-MM-DD"
                          format="DD MMM YYYY"
                          :partial-update="true"
                          :confirm="false"
                          popup-class="datetime-picker-doorder"
                          input-class="form-control form-control-astrology w-100" :append-to-body="false"
                        >
                          <template v-slot:icon-calendar
                            ><img
                              src="@/assets/images/astrology/calendar-input.png"
                            />
                          </template>
                        </date-picker>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <b-form-group
                        class="form-group-astrology form-group-date-astrology"
                        label-for="time"
                        label="Time"
                        label-class="form-label-astrology"
                      >
                        <p
                          v-if="invalid_time"
                          class="error_validation_message_p_astrology"
                        >
                          Please enter time
                        </p>
                        <date-picker
                          v-model="_time"
                          type="time"
                          value-type="format"
                          format="hh:mm a"
                          :partial-update="true"
                          :confirm="false"
                          popup-class="datetime-picker-doorder"
                          input-class="form-control form-control-astrology w-100" :append-to-body="false"
                        >
                          <template v-slot:icon-calendar
                            ><img
                              src="@/assets/images/astrology/clock-input.png"
                            />
                          </template>
                        </date-picker>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-group
                        class="form-group-astrology"
                        label="Location"
                        label-for="location"
                        label-class="form-label-astrology"
                      >
                        <p
                          v-if="invalid_location"
                          class="error_validation_message_p_astrology"
                        >
                          Please select postcode
                        </p>
                        <p
                          v-if="invalid_longitude || invalid_latitude"
                          class="error_validation_message_p_astrology"
                        >
                          Please select correct location
                        </p>
                        <vue-google-autocomplete
                          id="location"
                          classname="form-control form-control-astrology h-auto"
                          placeholder="Location"
                          types="(cities)"
                          v-model="_location"
                          v-on:placechanged="savePlace"
                          @keypress.enter="$event.preventDefault()"
                          required
                        >
                        </vue-google-autocomplete>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col>
                      <b-button
                        type="submit"
                        variant="astrology-primary"
                        class="
                          w-100
                          btn-bumblebee btn-astrology btn-astrology-submit
                        "
                      >
                        Create
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card></b-container
            >
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import VueGoogleAutocomplete from "vue-google-autocomplete";

import axios from "axios";
import $ from "jquery";
export default {
  name: "BirthChartInputData",
  components: { VueGoogleAutocomplete, DatePicker },
  props: ["is_birth_chart","name","gender","date","time","location"],
  data() {
    return {
      client_name: "AV",
      invalid_gender: null,
      gender_options: [
        { label: "Male", code: "male" },
        { label: "Female", code: "female" },
      ],
      invalid_date: false,
      invalid_time: false,
      invalid_location: false,
      invalid_latitude: false,
      invalid_longitude: false,
      latitude: null,
      longitude: null,
      is_loading: false,
    };
  },
  mounted() {},
  computed: {
    _name: {
      get() {
        return this.name;
      },
      set(value) {
        this.$emit("update:name", value);
      },
    },
    _gender: {
      get() {
        return this.gender;
      },
      set(value) {
        console.log("gender:",value)
        this.$emit("update:gender", value);
      },
    },
    _date: {
      get() {
        return this.date;
      },
      set(value) {
        this.$emit("update:date", value);
      },
    },
    _time: {
      get() {
        return this.time;
      },
      set(value) {
        this.$emit("update:time", value);
      },
    },
    _location: {
      get() {
        return this.location;
      },
      set(value) {
        this.$emit("update:location", value);
      },
    },
  },
  methods: {
    savePlace(place, placeResultData, id) {
      console.log(place);
      console.log(placeResultData);
      console.log(id);
      console.log(place.latitude, place.longitude);
      this.latitude = place.latitude;
      this.longitude = place.longitude;
      // this.location = placeResultData.formatted_address;
      this.$emit("update:location", placeResultData.formatted_address);
      // console.log(
      //   placeResultData.geometry.location.lat(),
      //   placeResultData.geometry.location.lng()
      // );
      // let index = id.split("_")[2];
      // console.log(index);
      // this.dropoff_eircode = placeResultData.name;
      // this.$emit("update:dropoff_eircode", placeResultData.name);
      // // this.dropoff_address = placeResultData.formatted_address;
      // this.$emit("update:dropoff_address", placeResultData.formatted_address);
      // // this.dropoff_latitude = place.latitude;
      // this.$emit("update:dropoff_latitude", place.latitude);
      // // this.dropoff_longitude = place.longitude;
      // this.$emit("update:dropoff_longitude", place.longitude);
      // // console.log(this.locations);
      // $("#" + id).val(placeResultData.name);
    },
    onSubmit() {
      console.log("submit create birth chart ");
      console.log(this.name, this.gender);
      console.log(this.date, this.time);
      console.log(this.location, this.latitude, this.longitude);

      if (this.gender == null || this.gender == "") {
        this.invalid_gender = true;
      } else {
        this.invalid_gender = false;
      }
      if (this.date == null || this.date == "") {
        this.invalid_date = true;
      } else {
        this.invalid_date = false;
      }
      if (this.time == null || this.time == "") {
        this.invalid_time = true;
      } else {
        this.invalid_time = false;
      }
      // if (this.location == null || this.location == "") {
      //   this.invalid_location = true;
      // } else {
      //   this.invalid_location = false;
      // }

      // if (this.latitude == null || this.latitude == "") {
      //   this.invalid_latitude = true;
      // } else {
      //   this.invalid_latitude = false;
      // }
      // if (this.longitude == null || this.longitude == "") {
      //   this.invalid_longitude = true;
      // } else {
      //   this.invalid_longitude = false;
      // }

      if (
        this.invalid_gender ||
        this.invalid_date ||
        this.invalid_time ||
        this.invalid_location ||
        this.invalid_latitude ||
        this.invalid_longitude
      ) {
      } else {
        this.$emit("update:is_birth_chart", true);
      }
    },
  },
};
</script>
<style scoped>
body {
  min-height: 100vh !important;
}
</style>


// WEBPACK FOOTER //
// src/components/astrology_ventures/customer/birth_chart/BirthChartInputData.vue